import {IntercomDataDto, MemberDto} from "../generated/dashboard-client";
import {formatPrice, getCookieValue} from "../util/utils";

function getPlanName(planId: string | undefined) {
  if (planId === '1059') return 'Annual Plan';
  if (planId === '1060') return 'Monthly Plan';
  return 'Free Plan';
}

function getStatus(member: MemberDto) {
  switch (member.status) {
    case 1: return "Active Premium";
    case 5: return "Active Free";
    case 2: return "On Hold";
    case 3: return "Cancelled";
    case 4: return "Declined";
    case 6: return "Paused";
    case 7: return "Past due";
    case 8: return "Removed";
    case -1: return "Any";
    default: return null;
  }
}

function getDate(date: string | undefined) {
  if (!date) return undefined;
  return new Date(date).getTime() / 1000;
}

function getRenewalDateFormatted(date: string | undefined) {
  if (!date) return undefined;
  return new Date(date).toLocaleDateString('en-US');
}

export const ChatService = {
  init(member: MemberDto) {
    window.$zoho?.salesiq?.visitor?.id(member.id);
    window.$zoho?.salesiq?.visitor?.name(member.name);
    window.$zoho?.salesiq?.visitor?.email(member.email);
    window.$zoho?.salesiq?.visitor?.info({
      user_id: `${member.internalId}`,
      team_owner_id: member.ownerId,
      team_id: member.teamId,
      server: getCookieValue("SRVID"),
      utm_source: getCookieValue("utm_source"),
      utm_medium: getCookieValue("utm_medium"),
      utm_campaign: getCookieValue("utm_campaign"),
      status: getStatus(member),
      fs_url: (window as any)['FS'] ? (window as any)['FS'].getCurrentSessionURL() : null,
      account_created: new Date(member.createdDate!).toString(),
    });
  },

  newMessage() {
    window.$zoho?.salesiq?.chat?.start();
  },

  addMemberDetails(data: IntercomDataDto) {
    if (!data) return;

    window.$zoho?.salesiq?.visitor?.info({
      customer_level: data.customerLevel,
      has_abandoned_cart: data.hasAbandonedCart === 'true',
      has_ds_project: data.hasDsProject === 'true',
      last_order_date: getDate(data.lastOrderDate),
      last_print_order: getDate(data.lastPrintOrder),
      plan_id: data.planId,
      plan_name: getPlanName(data.planId),
      addon_products: data.addonProducts,
      renewal_rate: formatPrice(data.renewalRate || 0),
      renewal_date: getRenewalDateFormatted(data.renewalDate),
      pos: data.pos,
      businessName: data.businessName,
    })
  },
  //
  //
  // update(data: any) {
  //   window.Intercom("update", data);
  // },
  //
  // show() {
  //   window.Intercom("update", {
  //     hide_default_launcher: false,
  //   });
  // }
};
